import { Grid, Button } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FormAlongsideText from './FormComponents/FormAlongsideText';
import ICommonFormProps from './interfaces/ICommonFormProps';

export function FieldFormExtender(props: ICommonFormProps) {
    const { control, keyName, className, formProps } = props;
    const { t } = useTranslation();
    const { Component, createNewObjectFunction } = formProps as any;

    if (!Component) console.error('no component set');

    const { fields, append, remove } = useFieldArray({
        control,
        name: keyName,
        keyName: 'key',
    });
    function addNewItem() {
        append(createNewObjectFunction());
    }
    return (
        <Grid container spacing={1} className={className}>
            <Grid item xs={12}>
                <FormAlongsideText
                    label={props.label}
                    secondLabel={props.formProps?.secondLabel as string}
                    secondLabelJSX={props.formProps?.secondLabelJSX}
                />
            </Grid>
            {props.formProps?.rowColumns && fields.length > 0 && props.formProps?.rowColumns}
            {fields.map((field, index) => (
                <Component {...props} key={field.key} index={index} onDelete={() => remove(index)} />
            ))}
            <Grid item xs={12}>
                {!props.disabled && (
                    <Button
                        data-component-name={'EXTENDER_BUTTON'}
                        onClick={addNewItem}
                        disabled={props.disabled}
                        variant="outlined"
                        style={{ color: '#212121', borderColor: '#C1CAE1!important' }}
                        className={props.formProps?.btnClassName}
                    >
                        {' '}
                        <Add style={{ paddingRight: '0.625rem', fontSize: '2rem' }} />{' '}
                        {t(props.formProps?.buttonLabel as string)}
                    </Button>
                )}
            </Grid>
        </Grid>
    );
}
